export const iconFontAwesomeMusicVideoFileAudio = (
	<i className="fa-solid fa-file-audio"></i>
);
